function renderBuildUiImportsImportsTemplate({ join }: { join: string }): string {
  return `import {
  ${join}
} from '@admin/components/ui/form'`
}

function renderBuildUiImportsImportsDetailsTemplate(): string {
  return `import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger
} from '@admin/components/ui/select'`
}

function renderBuildUiImportsImportsDetailsBranchTemplate({ join }: { join: string }): string {
  return `import {
  ${join}
} from '@admin/components/ui/command'`
}

function renderBuildUiImportsImportsDetailsBranchBodyTemplate(): string {
  return `import {
  Popover,
  PopoverContent,
  PopoverTrigger
} from '@admin/components/ui/popover'`
}

function renderTooltipImports(): string {
  return `import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from '@admin/components/ui/tooltip'`
}

function renderTabsImports(): string {
  return `import {
  Tabs,
  TabsList,
  TabsTrigger,
  TabsContent
} from '@admin/components/ui/tabs'`
}

function renderAccordionImports(): string {
  return `import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger
} from '@admin/components/ui/accordion'`
}

export function renderBuildUiImportsRenderer(
  request:
    | { kind: 'renderBuildUiImportsImportsTemplate'; props: { join: string } }
    | { kind: 'renderBuildUiImportsImportsDetailsTemplate' }
    | {
        kind: 'renderBuildUiImportsImportsDetailsBranchTemplate'
        props: {
          join: string
        }
      }
    | { kind: 'renderBuildUiImportsImportsDetailsBranchBodyTemplate' }
    | { kind: 'renderTooltipImports' }
    | { kind: 'renderTabsImports' }
    | { kind: 'renderAccordionImports' }
): string {
  switch (request.kind) {
    case 'renderBuildUiImportsImportsTemplate':
      return renderBuildUiImportsImportsTemplate(request.props)
    case 'renderBuildUiImportsImportsDetailsTemplate':
      return renderBuildUiImportsImportsDetailsTemplate()
    case 'renderBuildUiImportsImportsDetailsBranchTemplate':
      return renderBuildUiImportsImportsDetailsBranchTemplate(request.props)
    case 'renderBuildUiImportsImportsDetailsBranchBodyTemplate':
      return renderBuildUiImportsImportsDetailsBranchBodyTemplate()
    case 'renderTooltipImports':
      return renderTooltipImports()
    case 'renderTabsImports':
      return renderTabsImports()
    case 'renderAccordionImports':
      return renderAccordionImports()
  }

  throw new Error('Unsupported renderer request')
}
